import { useAppSelector, useAppDispatch } from '../../hooks'
import { selectGroupIds } from 'src/app/hostSettings'
import GroupItem from '../GroupItem'
import { setType } from 'src/app/modal'

const ManageGroups = () => {
  const dispatch = useAppDispatch()
  const groupIds = useAppSelector(selectGroupIds)
  const groupsList = Object.keys(groupIds).map((groupId) => {
    const key = groupId
    const groupName = groupIds[groupId]
    const onEdit = () => {
      dispatch(setType({ type: 'groupRename', props: { groupId } }))
    }
    const onDelete = () => {
      dispatch(setType({ type: 'groupDelete', props: { groupId } }))
    }
    return { key, groupId, groupName, onEdit, onDelete }
  })

  const onCreate = () => {
    dispatch(setType({ type: 'groupCreate' }))
  }

  return (
    <div className="mb-4">
      <p className="text-darkBlack mr-2 mb-2">Manage Tags</p>
      <p className="text-xs text-grey">Use Tags to categorize and filter Sessions in the Leaderboard. Create, edit, or delete Tags here.</p>
      <div className="mb-4">
        {groupsList.map((groupContent) => (
          <GroupItem {...groupContent} />
        ))}
      </div>
      <button onClick={onCreate} className="text-sm text-primaryBlue">
        + Create New Tag
      </button>
    </div>
  )
}

export default ManageGroups
